module.exports = __webpack_public_path__ + "assets/manage_bac.0218d90b79d55efb4d32268c9a2d44d8.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/manage_bac.png
// module id = 619
// module chunks = 0